import React from "react";
import { Client } from "@stomp/stompjs";
import { EventsContext } from "src/contexts/context";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
const socketUrl=process.env.REACT_APP_SOCKET_ENDPOINT;
const SOCKET_URL = `ws://${socketUrl}/ws-message`;
const icons = [
  <CheckCircleIcon />,
  <ReportProblemIcon
    htmlColor="yellow"
    sx={{ fill: "rgb(255, 564, 253) !important" }}
  />,
  <ReportProblemIcon
    htmlColor="orange"
    sx={{ fill: "rgb(255, 564, 253) !important" }}
  />,
  <ReportProblemIcon
    htmlColor="red"
    sx={{ fill: "rgb(255, 564, 253) !important" }}
  />,
  <CancelIcon />,
];
class Events_Stomp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: "You server message here.",
      events: 0,
    };
  }

  componentDidMount() {
    //method is called after the component is rendered.
    let currentComponent = this;
    let onConnected = () => {
          // client.subscribe('/topic/monitor', function (msg) {
          client.subscribe("/topic/monitor", async (msg) => {
            await setTimeout(() => {
            //  console.log("monitor subscription!!");
              if (msg.body) {
                // console.log("new Event with body:" + msg.body);

                var jsonBody = JSON.parse(msg.body);
                if (jsonBody) {
                  //if jsonBody == truthy

                  // currentComponent.context.setSuccess({ status: true, message: 'new Event with body:'+ msg.body })
                  // console.log(currentComponent.state);
                  currentComponent.context.setEvents((events) => {
                    if (events.data.length === 100) {
                      events.data.shift();
                    }
                    var counter = events.counter + 1;
                    var event = {
                      id: events.counter,
                      icon: icons[jsonBody.criticity],
                      position:
                        jsonBody.orgName +
                        " - " +
                        jsonBody.siteName +
                        " - " +
                        jsonBody.buildingName +
                        " - " +
                        jsonBody.assetName,
                      title: jsonBody.item_sn,
                      type: jsonBody.item_field,
                      value: jsonBody.value,
                      valueWithOutUnit:jsonBody.value.split(' ')[0],
                      date: new Date().toLocaleString(),
                      details: counter,
                    };
                    return { data: [...events.data, event], counter: counter };
                  });
                  //console.log("Delayed for 2 second.");
                  //console.log(currentComponent.state);
                }
              }
            }, 2000);
           });
    };

    let onDisconnected = () => {
      console.log("Disconnected!!");
    };

    const client = new Client({
      brokerURL: SOCKET_URL,
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      onConnect: onConnected,
      onDisconnect: onDisconnected,
    });

    client.activate();
  }

  render() {
    return (
      <div style={{ display: "none" }}>
        {/* <div style={{ color: "#FFF", marginBottom: "3rem" }}>
          {this.state.messages}
        </div> */}
      </div>
    );
  }
}

export default Events_Stomp;

Events_Stomp.contextType = EventsContext;
